import { createFileRoute } from '@tanstack/react-router'
import { CustomerCallVendorsPage } from '@/features/customer/pages/call-vendors'

export const Route = createFileRoute('/_authenticated/customer/call-vendors')({
  component: CustomerCallVendorsPage,
})
